import { RouteComponentProps, withRouter } from 'react-router-dom';
import { RouteParams } from '../../../../../core/models/RouteParams';
import ProjectContractorItemsExportForm from './ProjectContractorItemsExportForm';

interface OwnProps {
    projectId: number;
    projectContractorId: number;
    onClose: () => void;
    onSuccess: () => void;
}

export type Props = OwnProps & RouteComponentProps<RouteParams>;

export default withRouter(ProjectContractorItemsExportForm);
